import axios from 'axios';
import { getApiRoute } from '../../config';
import store from '../store';
// import MockAdapter from 'axios-mock-adapter';

/*
Change baseURL to suit your project needs.
*/
const http = axios.create({
  baseURL: process.env.VUE_APP_API_BASEURL,
  timeout: 5000,
});

http.interceptors.request.use((requestConfig) => {
  const { deviceId, betshopId, companyId, deviceToken, token } = store.state;
  const config = store.getters.getGameGetter({ getter: 'config' });
  const { tenantId, productId, locale, platformDataCenter } = config;

  const routes = {
    aggregatorURL: getApiRoute('baseURL', { productName: 'crashcash' }),
    socketUrl: getApiRoute('webSocketUrl', { productName: 'crashcash' }),
    sevenUrl: getApiRoute('baseURL', { productName: 'luckysix', platformDataCenter }),
    resultsUrl: getApiRoute('gameResults', { productName: 'luckysix' }),
    ngsUrl: getApiRoute('ngsURL', { productName: 'luckysix', platformDataCenter }),
  };

  const isMatchingUrl = (url) => requestConfig.url?.includes(url);
  const setHeaders = (headers) => Object.assign(requestConfig.headers, headers);

  if (isMatchingUrl(routes.aggregatorURL) || isMatchingUrl(routes.socketUrl)) {
    if (token) setHeaders({ Authorization: `Bearer ${token}` });
  } else if (isMatchingUrl(routes.sevenUrl) || isMatchingUrl(routes.resultsUrl)) {
    setHeaders({
      Authorization: `Bearer ${token}`,
      'HTTP-X-NAB-COMPANY-ID': companyId,
      'HTTP-X-NAB-DEVICE-UUID': deviceId,
      'HTTP-X-NAB-DP': 'Retail',
      'HTTP-X-NAB-BETSHOP-ID': betshopId,
      'X-SEVEN-DEVICE-TOKEN': deviceToken,
      'Seven-Locale': locale,
    });

    if (isMatchingUrl(routes.resultsUrl)) {
      setHeaders({
        'X-NSFT-NGS-COMPANY': tenantId,
        'X-NSFT-NGS-PRODUCT': productId,
        'X-NSFT-SEVEN-COMPANY-UUID': tenantId,
      });
    }
  } else if (isMatchingUrl(routes.ngsUrl)) {
    setHeaders({
      'X-NSFT-NGS-COMPANY': tenantId,
      'X-NSFT-NGS-PRODUCT': productId,
      'Seven-Locale': locale,
      Authorization: `Bearer ${token}`,
    });
  }

  return requestConfig;
});

// IF you need to mock a response from axios you can use this snippet
// change the status code and the response
// if you enable this than all other requests that you make from the app will throw 404 error
// It can be changed probably in the config of the mock instance

// const mock = new MockAdapter(http);
// mock.onGet('https://games-aggregator.staging.de-3.nsoft.cloud/seven/tickets?cpvUuid=fbc5bb0d-d575-4619-b8be-4e8437b2368c&uuid=cb279b1b-9996-4291-973c-11c17818d583').reply(404, {
//   "ticket": {
//       "bets": [
//           {
//               "payIn": {
//                   "real": 1,
//                   "bonuses": []
//               },
//               "selections": [
//                   {
//                       "marketId": 1,
//                       "outcomeId": "4"
//                   }
//               ],
//               "selectedSystem": 1
//           }
//       ],
//       "product": "CrashCash",
//       "pendingStartedAt": 1697531356806,
//       "statusCheckTimeout": null,
//       "config": {
//           "availableTicketActions": {},
//           "statusConfig": {},
//           "pendingTicketCheckInterval": 10000,
//           "pendingTicketRejectPeriod": 30000,
//           "color": "#178685"
//       },
//       "indexDbfailed": false,
//       "localPin": "",
//       "availableActions": [],
//       "localStatus": "PENDING",
//       "taxVerified": false,
//       "taxData": {},
//       "printTemplate": null,
//       "loyaltyDetails": null,
//       "localRevisions": [],
//       "action": "Add",
//       "requestUuid": "60ac9fc4-018c-4a78-8d4e-2615ba083440",
//       "id": "-",
//       "lang": "bs",
//       "reqUuidCheck": "https://menhir.staging.gb.nsoftcdn.com/shop/tickets/request/",
//       "check": "https://menhir.staging.gb.nsoftcdn.com/shop/tickets/check/",
//       "partialUrl": "CrashCash/check.json",
//       "findBy": "requestUuid",
//       "translation": "Crash Cash",
//       "clientId": 186
//     },
//     "code": "499"
//   });

export default http;
